import { getUrlParams } from '../../../utils/shared/urlUtils';

const getAdditionalURLParams = location => {
    const { burstGroupUid, applicationSid } = getUrlParams(location);
    return { burstGroupUid, applicationSid };
};

export default getAdditionalURLParams;
